import { TableConfig } from '../../../components/table/Table';

export const initAuftragsresearchTableConfig = (): TableConfig => {
  return [
    {
      id: 1,
      columnName: 'Erfassungsdatum',
      attributName: 'datum',
      valueType: 'string',
    },
    {
      id: 2,
      columnName: 'Versanddatum',
      attributName: 'beladedatum',
      valueType: 'string',
    },
    {
      id: 3,
      columnName: 'Zustelldatum',
      attributName: 'zustellDatum',
      valueType: 'string',
    },
    {
      id: 4,
      columnName: 'Sendungsnummer.',
      attributName: 'spedeigennr',
      valueType: 'string',
    },
    {
      id: 5,
      columnName: 'Status',
      attributName: 'status',
      valueType: 'string',
    },
    {
      id: 6,
      columnName: 'Ereignisdatum',
      attributName: 'status_datum',
      valueType: 'string',
    },

    {
      id: 7,
      columnName: 'POD',
      attributName: 'abliefernachweisExists',
      valueType: 'sliderbutton',
    },
    {
      id: 8,
      columnName: 'Abs-Referenz',
      attributName: 'absenderReferenz',
      valueType: 'string',
    },
    {
      id: 9,
      columnName: 'Empf. MC',
      attributName: 'empfaenger_matchcode',
      valueType: 'string',
    },
    {
      id: 10,
      columnName: 'Empf-Name',
      attributName: 'empfaenger_name',
      valueType: 'string',
    },
    {
      id: 11,
      columnName: 'Empf-Strasse',
      attributName: 'empfaenger_strasse',
      valueType: 'string',
    },
    {
      id: 12,
      columnName: 'Empf-PLZ',
      attributName: 'empfaenger_plz',
      valueType: 'string',
    },
    {
      id: 13,
      columnName: 'Empf-Ort',
      attributName: 'empfaenger_ort',
      valueType: 'string',
    },
    {
      id: 14,
      columnName: 'Zustellart',
      attributName: 'zustellart',
      valueType: 'string',
    },
    {
      id: 15,
      columnName: 'Anz. Packstücke',
      attributName: 'sumPackstueckAnzahl',
      valueType: 'string',
    },
    {
      id: 16,
      columnName: 'Gewicht',
      attributName: 'sumBruttoGewicht',
      valueType: 'string',
    },
    {
      id: 17,
      columnName: 'ADR',
      attributName: 'mitGefahrguetern',
      valueType: 'sliderbutton',
    },
    {
      id: 18,
      columnName: 'Klassifizierung',
      attributName: 'sperrigkeit',
      valueType: 'string',
    },
    {
      id: 19,
      columnName: 'Empf-Referenz',
      attributName: 'empfaengerReferenz',
      valueType: 'string',
    },
    {
      id: 20,
      columnName: 'Partner Referenz',
      attributName: 'partnerreferenz',
      valueType: 'string',
    },
    {
      id: 21,
      columnName: 'Abs-Matchcode',
      attributName: 'absender_matchcode',
      valueType: 'string',
    },
    {
      id: 22,
      columnName: 'Abs-Name',
      attributName: 'absender_name',
      valueType: 'string',
    },
    {
      id: 23,
      columnName: 'Abs-PLZ',
      attributName: 'absender_plz',
      valueType: 'string',
    },
    {
      id: 24,
      columnName: 'Abs-Ort',
      attributName: 'absender_ort',
      valueType: 'string',
    },
    {
      id: 25,
      columnName: 'Abs-Strasse',
      attributName: 'absender_strasse',
      valueType: 'string',
    },
    {
      id: 26,
      columnName: 'Hinweis',
      attributName: 'hinweis',
      valueType: 'string',
    },
    {
      id: 27,
      columnName: 'RG-MC',
      attributName: 'rechnungsadresse_matchcode',
      valueType: 'string',
    },
    {
      id: 28,
      columnName: 'RG-Name',
      attributName: 'rechnungsadresse_name',
      valueType: 'string',
    },
    {
      id: 29,
      columnName: 'RG-Strasse',
      attributName: 'rechnungsadresse_strasse',
      valueType: 'string',
    },
    {
      id: 30,
      columnName: 'RG-PLZ',
      attributName: 'rechnungsadresse_plz',
      valueType: 'string',
    },
    {
      id: 31,
      columnName: 'RG-Ort',
      attributName: 'rechnungsadresse_ort',
      valueType: 'string',
    },
    {
      id: 32,
      columnName: 'NN-Name',
      attributName: 'nachnahmeadresse_name',
      valueType: 'string',
    },
    {
      id: 33,
      columnName: 'NN-Strasse',
      attributName: 'nachnahmeadresse_strasse',
      valueType: 'string',
    },
    {
      id: 34,
      columnName: 'NN-PLZ',
      attributName: 'nachnahmeadresse_plz',
      valueType: 'string',
    },
    {
      id: 35,
      columnName: 'NN-Ort',
      attributName: 'nachnahmeadresse_ort',
      valueType: 'string',
    },
    {
      id: 36,
      columnName: 'Preis',
      attributName: 'berechnBetrag',
      valueType: 'float',
      fixedDecimalScale: true,
    },
    {
      id: 37,
      columnName: 'in',
      attributName: 'berechnWaehrung',
      valueType: 'string',
    },
    {
      id: 38,
      columnName: 'Mandant',
      attributName: 'mandant',
      valueType: 'string',
    },
  ];
};
